import React, { useState, useEffect, useContext } from 'react'

import { hpContext } from '../../HPContext';
import HpTopHead from './head/HpTopHead';
import HpContentPoint from './point/HpContentPoint';
import HpContentFunction from './functions/HpContentFunction';
import HpContentHowto from './howto/HpContentHowto';
import HpContentFeel from './feel/HpContentFeel';
import HpContentDownload from './download/HpContentDownload';

import HpContentOpenApp from './openApp/HpContentOpenApp';


function Top(props) {
  const ReactGA = useContext(hpContext).ReactGA;

  const isOpenApp = props.isOpenApp;

  useEffect(() => {
    // ログ：ページ
    ReactGA.event("pageTop");
  }, [])

  return (
    <div id="container">

      <HpTopHead />

      <HpContentPoint />
      <HpContentFunction />
      <HpContentHowto />
      <HpContentFeel />
      <HpContentDownload />

      {/* アプリ起動モーダル */}
      <HpContentOpenApp
        isOpenApp={isOpenApp}
      />

    </div> 
  );
}

export default Top;
